import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Drawer } from '../Drawer';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';

const meta: Meta<typeof Drawer> = {
  title: 'Components/Drawer',
  component: Drawer,
};

export default meta;
type Story = StoryObj<typeof Drawer>;

export const Default: Story = {
  render(props: Partial<React.ComponentProps<typeof Drawer>>) {
    const [show, setShow] = React.useState(false);

    return (
      <div>
        <Button onClick={() => setShow(true)}>Open Drawer</Button>
        <Drawer show={show} onRequestHide={() => setShow(false)} closeOnClickOutside {...props}>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis eius magnam aliquam suscipit dolor
            recusandae, ut consectetur quidem aliquid. Assumenda accusantium repellat cum totam quae ipsum dolor
            recusandae beatae excepturi! Eligendi cum accusantium magnam ad praesentium ab quam voluptatum, itaque odit
            consequatur amet non aliquid minima enim fuga obcaecati officiis.
          </p>
        </Drawer>
      </div>
    );
  },
};

export const WithTooltip: Story = {
  render(props: Partial<React.ComponentProps<typeof Drawer>>) {
    const [show, setShow] = React.useState(false);

    return (
      <div>
        <Button onClick={() => setShow(true)}>Open Drawer</Button>
        <Drawer show={show} onRequestHide={() => setShow(false)} closeOnClickOutside {...props}>
          <p style={{ marginBottom: 16 }}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis eius magnam aliquam suscipit dolor
            recusandae, ut consectetur quidem aliquid. Assumenda accusantium repellat cum totam quae ipsum dolor
            recusandae beatae excepturi! Eligendi cum accusantium magnam ad praesentium ab quam voluptatum, itaque odit
            consequatur amet non aliquid minima enim fuga obcaecati officiis.
          </p>
          <Tooltip contents={<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, exercitationem!</p>}>
            <Button>Hover Me</Button>
          </Tooltip>
        </Drawer>
      </div>
    );
  },
};
